import React from 'react';

import { useGetClientReminders } from '../../common/useGetClientReminders';
import { RemindersTableWithAddOption } from '../../components/RemindersTableWithAddOption';

export const ClientRemindersTable: React.FC<{ clientId: string }> = ({ clientId }) => {
  const { data } = useGetClientReminders(clientId);

  return <RemindersTableWithAddOption objectId={clientId} objectClass="CLIENT" data={data} />;
};
